import React, { useState, useEffect } from 'react'
import Carousel from 'react-bootstrap/Carousel'
import ReactMarkdown from 'react-markdown'
import PropTypes from 'prop-types'
import useAllSitePage from '../../hooks/useAllSitePage'
import { useWindowSize } from '../../helpers/useWindowSize'
import Button from '../../shared/Button/Button'
import { useSelector } from 'react-redux';
import './Carousel.scss'

const Carousels = ({
  carousel,
  keyName = '',
  isHome = false,
  bannerCarousel = false
}) => {
 
  const pagesPath = useAllSitePage()
  const {
    allSitePage: matchPages
  } = pagesPath

  const menuMobileActive = useSelector(state => state.menu.menuMobileActive);

  const [slideStates, setSlidesState] = useState(null)
  const [width] = useWindowSize()

  useEffect(() => {
    setSlidesState(
      carousel.slide
        ? (carousel.slide?.filter((slide) => slide.visible === true)).length
        : null
    )
  }, [carousel])

  return (
    <>
      {carousel?.visible && (
        <Carousel
          style={{ 
            height: '100%', 
            minHeight: bannerCarousel ? '50vh' : isHome ? '100vh' : '85vh' 
          }}
          className="carousel custom-carousel flex-grow-1 d-flex"
          slide={slideStates > 1}
          indicators={slideStates > 1}
          controls={slideStates > 1}
        >
          {carousel.slide?.length > 0
            ? carousel.slide.map((slide, i) => {
              if (slide.visible) {
                return (
                  <Carousel.Item
                    interval={10000}
                    key={`idSlide-${keyName + i}`}
                    className="h-100"
                  >
                    <div
                      role="img"
                      alt={slide.imageDescription || ''}
                      className="h-100 d-flex video-mobile"
                      style={{
                        backgroundImage: 
                        (width <= 576 && slide.imageMobile) ? `url(${slide.imageMobile?.url})`  :
                        slide.backgroundImage?.url
                          ? `url(${slide.backgroundImage.url})`
                          : '',
                        backgroundPosition: 'center'
                      }}
                    >
                      {slide?.backgroundVideo && width >= 1200 && (
                        <div className="position-absolute video-background w-100 h-100 d-flex align-items-center justify-content-between">
                          <div className="carousel-embed">
                            <video
                              src={slide.backgroundVideo.url}
                              preload="auto"
                              className="carousel-video"
                              autoPlay
                              muted
                              loop
                            />
                          </div>
                        </div>
                      )}

                      {/* Aplicando FIltros a Imagenes de los "slides" */}
                      <div
                        className={`${isHome
                            ? 'slide-background-home'
                            : slide.imageFilter && slide.imageFilter === true
                              ? 'slide-background'
                              : null
                          } flex-grow-1 d-flex flex-column justify-content-center text-white`}
                      >
                        {slide.content && (
                          <div className="container-xl">
                            <div className="row">
                              <div className="col-12 p-5">
                                <div className=" info-cont">
                                  {!menuMobileActive ? (
                                    <div
                                      className={
                                        slide.content != null ||
                                          slide.p_ucc_microsite?.slug ||
                                          slide.p_ucc_page?.slug ||
                                          slide.p_ucc_career?.slug ||
                                          slide.url
                                          ? 'slide-card'
                                          : null
                                      }
                                    >
                                      <ReactMarkdown
                                        rehypePlugins={false}
                                        children={slide.content}
                                        className="fade-in-image markdown-format-carousel mb-3"
                                      />
                                      
                                      {(slide.p_ucc_microsite?.slug ||
                                        slide.p_ucc_page?.slug ||
                                        slide.p_ucc_career?.slug ||
                                        slide.url) && (
                                          <Button
                                            classButton={` carousel-button-style text-left button-form rounded-0`}
                                            button={
                                              {
                                                label: slide.textButton ? slide.textButton : slide.url ? 'IR A SITIO' : 'VER MÁS',
                                                ...slide
                                              }
                                            }
                                            customButton={{ variant: 'light_outline', size: "", shape: 'pill' }}
                                            classContainer=" d-flex"
                                            matchPages={matchPages?.nodes}
                                          />
                                        )
                                      }
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </Carousel.Item>
                )
              } else {
                return null
              }
            })
            : null}
        </Carousel>
      )}
    </>
  )
}

export default Carousels

Carousels.propTypes = {
  carousel: PropTypes.object.isRequired,
  keyName: PropTypes.string,
  isHome: PropTypes.bool,
  pages: PropTypes.array
}
